// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a[data-v-c3c7cc02]{display:none;text-decoration:none}@media(min-width:900px){a[data-v-c3c7cc02]{display:block}}svg[data-v-c3c7cc02]{width:184px;margin:0}svg text[data-v-c3c7cc02]{font-size:18px;transition:.25s;text-transform:uppercase;font-weight:700}svg path[data-v-c3c7cc02]{fill:#f04740;transition:.25s}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
